import { render } from "./side-settings.vue?vue&type=template&id=eef26280"
import script from "./side-settings.vue?vue&type=script&lang=js"
export * from "./side-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__